import React, {useState, useEffect} from 'react'
import WarningModal from '../../../../modals/WarningModal'
import { onGetErrorMessage } from '../../../../shared/utility'
import { request_delete_lineitem } from '../requests'



const DeleteModal = props => {
 
    const { data, open, onClose, onUpdateCompleted } = props
  
    const [error, setError] = useState(null)
    const [loading, setLoading] = useState(false)
    const [disabled, setDisabled] = useState(false)

    const cart_id = data ? data.cart_id : null
    const id_line_item = data ? data.id_line_item : null

    useEffect(() => {
        setError('')
        setLoading(false)
        setDisabled(false)
    }, [open])

    const onSubmit = async() => {
        setLoading(true)
        setDisabled(true)
        try {
            await request_delete_lineitem(cart_id, id_line_item)          
            onUpdateCompleted()
            onClose()
        } catch (error) {
            console.log(error)
            setError(onGetErrorMessage(error))
            setLoading(false)
        }
        setDisabled(false)
    }

    return(
        <WarningModal open={open} onClose={onClose} error={error} loading={loading} onSubmit={onSubmit} disabled={disabled}/>
    )
}

export default DeleteModal